<template>
  <v-navigation-drawer app right color="grey lighten-2" width="375" touchless :value="drawerShow" @input="syncDrawer">
    <div class="px-4 py-5">
      <div class="text-right mb-5">
        <v-icon color="#c4c4c4" @click="toggleDrawer">mdi-close</v-icon>
      </div>
      <div>
        <MultiLangSelectorVue class="ml-auto" />
      </div>
      <div class="px-4 py-3 drawerItem cursor-pointer" @click="toAbout">
        {{ $t("nav_about") }}
      </div>
      <div class="px-4 py-3 drawerItem cursor-pointer" @click="toFAQ">
        {{ $t("nav_faq") }}
      </div>
      <div class="px-4 py-3 drawerItem cursor-pointer d-flex" :class="{ active: isExtend }" @click="isExtend = !isExtend">
        {{ $t("nav_member") }}
        <v-spacer />
        <v-icon :color="isExtend ? 'primary-1' : '#8d8d8d'">{{
          isExtend ? "mdi-menu-up" : "mdi-menu-down"
        }}</v-icon>
      </div>
      <v-expand-transition>
        <div class="members" v-if="isExtend">
          <div class="px-8 py-3 cursor-pointer" @click="$router.push({ name: 'OrderList' }).catch(() => { })">
            {{ $t("nav_order") }}
          </div>
          <div class="px-8 py-3 cursor-pointer" @click="$router.push({ name: 'Ticket' }).catch(() => { })">
            {{ $t("ticket_box_entry_title") }}
          </div>
          <div class="px-8 py-3 cursor-pointer" @click="$router.push({ name: 'UserInfo' }).catch(() => { })">
            {{ $t("nav_member_info") }}
          </div>
          <div class="px-8 py-3 cursor-pointer" @click="$router.push({ name: 'Contactus' }).catch(() => { })">
            {{ $t("nav_contact") }}
          </div>
          <div class="px-8 py-3 cursor-pointer" @click="$router.push({ name: 'Terms' }).catch(() => { })">
            {{ $t("nav_terms") }}
          </div>
        </div>
      </v-expand-transition>
      <div class="px-4 py-3 drawerItem cursor-pointer" @click="clickLogin" v-if="!$store.state.user.access_token">
        {{ $t("nav_login") }}
      </div>

      <div class="px-4 py-3 drawerItem" v-else>
        {{ $store.state.user.account }}
        <span class="ml-3 cursor-pointer" @click="clickLogout">{{
          $t("nav_logout")
        }}</span>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MultiLangSelectorVue from "../components/MultiLangSelector.vue";

export default {
  components: {
    MultiLangSelectorVue
  },
  data() {
    return {
      isExtend: false,
      langIsExtend: false,
    };
  },
  computed: {
    ...mapGetters(["drawerShow", "relogin"]),
  },
  watch: {
    needRelogin: {
      deep: true,
      handler: function (newVal, old) {
        if (newVal !== old && newVal) {
          this.clickLogin();
        }
      },
    },
  },
  mounted() {
    if (this.needRelogin) {
      this.clickLogin();
    }
  },
  methods: {
    ...mapActions({
      showLogin: "login/show",
      logout: "user/logoutToIndex",
    }),
    syncDrawer(state) {
      this.$store.dispatch("DrawerToggle", { state });
    },
    toggleDrawer() {
      this.$store.dispatch("DrawerToggle");
    },
    toAbout(e) {
      this.$router.push({ name: "About" }).catch(() => { });
    },
    toFAQ(e) {
      this.$router.push({ name: "FAQ" }).catch(() => { });
    },
    clickLogin(e) {
      this.showLogin();
    },
    clickLogout(e) {
      this.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  border-radius: $radiusDesktop 0 0 $radiusDesktop;
}

.drawerItem {
  background-color: $grey-lighten-1;
  color: $grey-darken-1;
  font-weight: bold;
  border-bottom: 1px white solid;

  +.active {
    background-color: white;
    color: $primary-dark;
  }
}

.members {
  border-top: 1px $border-grey solid;
  color: $primary-dark;
  background-color: white;
}
</style>
